


































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import DsCarousel from "@/components/ds-carousel/ds-carousel.vue";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import JianchaEdit from "../../components/jiancha/jiancha-edit.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    MainHeader,
    NavLeft,
    DsCarousel,
    DsEditor,
    LeaveConfirm,
    JianchaEdit,
  },
})
export default class Name extends Vue {
  private routerPath: any = "";
  private id: any = "";
  private detail: any = {
    pic_list: [],
  };
  private ifShowSaveConfirm: any = false;
  private noSaveText: any = "不保存，离开";

  private get patient() {
    return this.$store.state.patient;
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private get patientFileFilter() {
    return this.$store.state.patientFileFilter;
  }

  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    this.routerPath = to.fullPath;
    if (this.ifCompose) {
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
  }
}
